import React, { useState } from "react"
import { Button, Input, Label } from "reactstrap"
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa"
import { FetchPostData } from "utils/Common_api_functions"

// POST tab-passwords/verify  { tabName, password }
// FetchPostData returns the axios response on success and the axios error on failure.
const verifyTabPassword = async (tabName, password) => {
  const res = await FetchPostData(() => {}, "tab-passwords/verify", {
    tabName,
    password,
  })

  if (res?.status >= 200 && res?.status < 300 && res?.data?.success !== false)
    return { success: true }

  return {
    success: false,
    message:
      res?.response?.data?.message ||
      res?.data?.message ||
      "Incorrect password.",
  }
}

const PasswordInput = ({ value, onChange, placeholder, onEnter, autoFocus }) => {
  const [show, setShow] = useState(false)
  return (
    <div style={{ position: "relative" }}>
      <Input
        type={show ? "text" : "password"}
        value={value}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => e.key === "Enter" && onEnter?.()}
        style={{ paddingRight: "38px" }}
      />
      <span
        onClick={() => setShow(s => !s)}
        style={{
          position: "absolute",
          right: 12,
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#94a3b8",
        }}
      >
        {show ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
      </span>
    </div>
  )
}

// Wraps a page: asks for the tab's password and renders children only once verified.
// State is not persisted, so the password is asked every time the page is opened.
const TabPasswordGate = ({ tabName, title, children }) => {
  const [unlocked, setUnlocked] = useState(false)
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [checking, setChecking] = useState(false)

  const submit = async () => {
    if (!password) return setError("Please enter the password.")
    setError("")
    setChecking(true)
    const res = await verifyTabPassword(tabName, password)
    setChecking(false)
    if (res?.success) setUnlocked(true)
    else setError(res?.message || "Incorrect password.")
  }

  if (unlocked) return <>{children}</>

  return (
    <div
      className="page-content d-flex align-items-center justify-content-center"
      style={{ minHeight: "80vh" }}
    >
      <div
        className="bg-white shadow rounded-4"
        style={{ width: "100%", maxWidth: 400, padding: "32px 28px" }}
      >
        <div className="text-center mb-4">
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              background: "#eff6ff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 12,
            }}
          >
            <FaLock size={22} color="#3b82f6" />
          </div>
          <h4 style={{ margin: 0, fontWeight: 700, color: "#0f172a" }}>
            {title}
          </h4>
          <div style={{ fontSize: 13, color: "#64748b", marginTop: 4 }}>
            This section is password protected
          </div>
        </div>

        <Label className="mb-1">Password</Label>
        <PasswordInput
          value={password}
          onChange={setPassword}
          placeholder="Enter password"
          onEnter={submit}
          autoFocus
        />
        {error && <div className="text-danger mt-2 small">* {error}</div>}

        <Button
          className="bg-blue w-100 mt-3"
          onClick={submit}
          disabled={checking}
        >
          {checking ? "Verifying..." : "Unlock"}
        </Button>
      </div>
    </div>
  )
}

export default TabPasswordGate
